// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import BlockRoundSvg from '@rsuite/icon-font/lib/status/BlockRound';
var BlockRound = createSvgIcon({
  as: BlockRoundSvg,
  ariaLabel: 'block round',
  category: 'status',
  displayName: 'BlockRound'
});
export default BlockRound;